<template>
  <div>
    <h2 class="t-primary t-400 mb-1">Takeaways</h2>
    <p>
      Extract insights from the abstracts of the first 25 publications in your search results. Use “Sort by” to have your preferred results on top.
    </p>
    <hr class="hr-small mb-4" />
    <p v-if="isLoading">
      {{ loadingMessage }}
      <spinner :containerClass="`d-inline ml-4`" />
    </p>

    <div v-if="error" class="p-2 bd-radius bg-red t-white mb-4">
      {{ error }}
    </div>

    <div v-if="takeaways" style="max-height: 60vh; height: auto; overflow-y: scroll; white-space: pre-line;" class="form-control mb-4">
      <p v-html="takeaways" />
    </div>

    <div class="d-flex flex-row justify-content-end align-items-center mt-2">
      <span class="align-left"
        v-tooltip="'Takeaway requests are reset every Monday'"
      >{{ remainingPrompts }} takeaway requests left this week</span>
      <span class="flex-grow-1"><!-- spacer --></span>
      <button
        class="btn bg-transparent no-border t-primary ml-3"
        type="button"
        @click="$events.$emit('modal:close')">Close
      </button>

      <button
        v-if="!isLoading && takeaways"
        class="btn btn-primary px-4 ml-3"
        type="button"
        @click="()=>{}"
        v-clipboard="takeaways" @success="handleCopySuccess" @error="handleCopyError"
      >
        {{ copyCopy }}
      </button>
      <button
        v-if="!isLoading && remainingPrompts > 0 && !takeaways"
        class="btn btn-primary px-4 ml-3"
        type="button"
        @click="fetchTakeaways"
      >
        Try again
      </button>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/shared/Spinner'
import SearchService from '@/services/search'
// import { marked } from 'marked'

export default {
  name: 'takeawayModal',
  components: {
    Spinner
  },
  props: {
    state: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      error: '',
      isLoading: false,
      takeaways: '',
      copyCopy: 'Copy to Clipboard',
      loadingMessage: 'Generating takeaways, this can take a few seconds...',
      loadingTimer: 0,
      remainingPrompts: 0
    }
  },
  mounted () {
    this.setRemainingPrompts(this.$currentUser.prompts_remaining, true)

    if (this.remainingPrompts === 0) {
      this.error = 'Our AI needs a break! The Takeaways feature has been used 20 times this week, which is the current usage limit. It will be available to you again on Monday.'
    } else {
      this.fetchTakeaways()
    }
  },
  methods: {
    setRemainingPrompts (prompts, isInit) {
      if (!prompts || prompts < 0) this.remainingPrompts = 0
      else this.remainingPrompts = prompts

      if (isInit) return
      // Only updateCurrentUser when not in initalisation step
      this.$auth.updateCurrentUser({
        ...this.$currentUser,
        prompts_remaining: this.remainingPrompts
      })
    },
    processResponse (response) {
      if (this.state.keyword) {
        this.takeaways = `Query: ${this.state.keyword}`

        if (this.state.filters) {
          const filters = this.getActiveFilters(this.state.filters)

          if (filters.length > 0) {
            this.takeaways += ` + ${filters.length} ${this.$options.filters.pluralize('filter', filters.length)}`
          }
        }
        this.takeaways += '\n\n'
      }
      this.takeaways += response
    },
    fetchTakeaways () {
      this.isLoading = true
      this.error = ''
      this.takeaways = ''
      this.loadingMessage = 'Generating takeaways, this can take a few seconds...'

      this.loadingTimer = setTimeout(() => {
        this.loadingMessage = 'Just a bit longer, your takeaways are almost there!'
      }, 20000)

      SearchService.getTakeaways({
        ...this.state
        // url: this.$route.fullPath
      }).then(response => {
        clearTimeout(this.loadingTimer)
        this.isLoading = false
        this.processResponse(response.data)
        this.setRemainingPrompts(response.prompts_remaining)
      }).catch(err => {
        if (err.status === 401) {
          this.setRemainingPrompts(0)
          this.error = 'Our AI needs a break! The Takeaways feature has been used 20 times this week, which is the current usage limit. It will be available to you again on Monday.'
        } else if (err.status === 400) {
          this.error = 'Oops, our AI has stumbled! An unexpected error has occured. Please try again.'
        } else {
          this.error = 'Oops, something unexpected has happened. Please try again later.'
        }
        this.isLoading = false
      })
    },
    handleCopySuccess () {
      this.copyCopy = 'Succesfully copied!'
      setTimeout(this.resetCopy, 2500)
    },
    handleCopyError () {
      this.copyCopy = 'Could not copy text to clipboard, please try manually.'
      setTimeout(this.resetCopy, 2500)
    },
    resetCopy () {
      this.copyCopy = 'Copy to Clipboard'
    }
  }
}
</script>
